// validations.ts
import * as yup from "yup";

export const phoneValidationSchema = yup.object().shape({
  phone: yup
    .string()
    .required("Phone number is required")
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),
});

export const otpValidationSchema = yup.object().shape({
  phone: yup
    .string()
    .required("Phone number is required")
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),
  otp: yup
    .string()
    .required("OTP is required")
    .matches(/^[0-9]{4,6}$/, "OTP must be 4-6 digits"),
});
